import React, {Component, createContext} from "react";
import Fire from "./Fire";
import {LoadingLogo} from "../loading/loading-logo";
import gql from "graphql-tag";
import APIClient from "../../components/ApolloClientComponent/ApolloClient";

import Swal from "sweetalert2";

const defaultFirebaseContext = {
	authStatusReported: false,
	isUserSignedIn: false
};

export const FirebaseAuthContext = createContext(defaultFirebaseContext);

class FirebaseAuthProvider extends Component {
	state = defaultFirebaseContext;

	componentDidMount() {
		this.unregister = Fire.auth().onAuthStateChanged(user => {
			if (user) {
				user.getIdTokenResult(true)
					.then(async (token) => {
						console.log(user);
						console.log(token);			
						if (token.claims.company) {
							this.setState({
								authStatusReported: true,
								isUserSignedIn: true
							});
						} else {
							if (token.claims.email) {
								const mutation = gql`
								mutation createCompanyGoogleAuth(
									$name: String!
									$firstName: String!
									$lastName: String!
									$size: Int!
									$isStartUp: Boolean!
									$establishmentYear: String
									$industry: ID!
									$email: String!
									$password: String!
									$phone: String
								) {
									createCompanyGoogleAuth(
										company: {
											name: $name
											size: $size
											isStartup: $isStartUp
											establishmentYear: $establishmentYear
											industry: $industry
											email: $email
											phone: $phone
										}
										defaultAdmin: {
											firstName: $firstName
											lastName: $lastName
											email: $email
											phone: $phone
											password: $password
										}
									) {
										id
									}
								}
							`;
								const result = await APIClient.mutate({
									mutation: mutation,
									variables: {
										firstName: user.displayName.split(" ")[0],
										lastName: user.displayName.split(" ")[1],
										name: user.displayName,
										size: -1,
										isStartUp: false,
										establishmentYear: "",
										industry: "",
										email: user.email,
										phone: "",
										password: Math.random().toString(36).slice(-8),
									},
									errorPolicy: "all"
								});
								if (result.errors) {
									Swal.fire({
										type:"warning",
										text: result.errors[0].message,
										animation: false,
										width:350,
										customClass:{confirmButton:"sweet-alert-button"}
									});
								}
								else {
									this.setState({
										authStatusReported: true,
										isUserSignedIn: true
									});
								}
							}
						}
					});
			} else {
				this.setState({
					authStatusReported: true,
					isUserSignedIn: false
				});
			}
		});
	}

	// componentWillUnmount() {
	// 	this.unregister();
	// }

	render() {
		const {children} = this.props;
		const {authStatusReported, isUserSignedIn} = this.state;
		const component = authStatusReported ? children : (
			<LoadingLogo style={{position: "absolute", height: "100%", width: "100%"}}/>
		);
		return (
			<FirebaseAuthContext.Provider
				value={{isUserSignedIn, authStatusReported}}
			>
				{component}
			</FirebaseAuthContext.Provider>
		);
	}
}

export default FirebaseAuthProvider;
